<template>
  <b-container fluid>
    <backlink/>
    <h1>Entrepôts</h1>

    <AdminTable :config="config">
      <!-- URL du formulaire Chronopost : l'icône signale qu'elle est saisie. -->
      <template slot="chronopost" slot-scope="{ data }">
        <i v-if="data.item.chronopost_url" class="far fa-check-circle warehouse-chronopost"></i>
      </template>

      <!--
        Coordonnées GPS. Un entrepôt qui n'en a pas fait basculer le calcul de transport en
        zone maximale (TransportFeeCalculator::resolveDistance) — effet silencieux, d'où
        l'alerte plutôt qu'une cellule vide. Le dispatch, lui, ne s'appuie que sur la table
        département -> entrepôt, jamais sur les coordonnées.
      -->
      <template slot="coordinates" slot-scope="{ data }">
        <span v-if="hasCoordinates(data.item)">
          {{ data.item.latitude }}, {{ data.item.longitude }}
        </span>
        <span
          v-else
          class="warehouse-no-coordinates"
          v-b-tooltip.hover
          title="Coordonnées absentes : les frais de transport au départ de cet entrepôt partent en zone maximale."
        >
          <i class="far fa-exclamation-triangle"></i> Non renseignées
        </span>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "WarehouseList",
  components: {
    AdminTable
  },
  data() {
    return {
      config: config
    };
  },
  methods: {
    /**
     * Les deux coordonnées font paire : une latitude seule ne situe rien, et le back exige
     * les deux avant de calculer quoi que ce soit. Le 0 reste une valeur valable (équateur,
     * méridien de Greenwich), seul l'absence compte.
     * @param   {object}  warehouse Ligne de la liste
     * @returns {boolean}           True si les deux coordonnées sont renseignées
     */
    hasCoordinates(warehouse) {
      return (
        warehouse.latitude !== null &&
        warehouse.latitude !== undefined &&
        warehouse.latitude !== "" &&
        warehouse.longitude !== null &&
        warehouse.longitude !== undefined &&
        warehouse.longitude !== ""
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

// Pas `text-danger` : le thème lui donne #FFE2E6, un rose prévu comme FOND de badge et
// illisible en texte. L'alerte prend le rouge vif du thème, assombri et gras pour ressortir
// sur une ligne de tableau où tout le reste est en gris foncé.
.warehouse-no-coordinates {
  color: darken($red, 10%);
  font-weight: 700;
  white-space: nowrap;

  .fa-exclamation-triangle {
    font-size: 1.15em;
    vertical-align: -1px;
  }
}

.warehouse-chronopost {
  color: $green;
  font-size: 1.15em;
}
</style>



// WEBPACK FOOTER //
// src/components/Warehouse/WarehouseList.vue